import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCreateAuthor } from '../hooks/useAuthors';

interface AuthorFormProps {
  onSuccess?: () => void;
  onCancel?: () => void;
}

export const AuthorForm: React.FC<AuthorFormProps> = ({ onSuccess, onCancel }) => {
  const navigate = useNavigate();
  const createAuthor = useCreateAuthor();
  const [name, setName] = useState('');
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!name.trim()) { setError('Name ist erforderlich'); return; }
    setError(null);
    createAuthor.mutate(name.trim(), {
      onSuccess: () => {
        setName('');
        onSuccess?.();
        navigate('/authors');
      },
      onError: (err: unknown) => {
        const detail = (err as { response?: { data?: { detail?: string } } }).response?.data?.detail;
        setError(detail ?? 'Fehler beim Speichern. Bitte versuche es erneut.');
      },
    });
  };

  return (
    <div className="max-w-lg mx-auto">
      <div className="bg-white rounded-lg shadow-md p-6">
        <h2 className="text-xl font-bold text-gray-900 mb-6">
          Neuen Autor erstellen
        </h2>

        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Name */}
          <div>
            <label
              htmlFor="name"
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              Name <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              id="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="z.B. Hermann Hesse"
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              disabled={createAuthor.isPending}
            />
            <p className="text-sm text-gray-500 mt-1">
              Der vollständige Name des Autors
            </p>
          </div>

          {/* Fehleranzeige */}
          {error && (
            <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-md">
              {error}
            </div>
          )}

          {/* Buttons */}
          <div className="flex gap-3">
            <button
              type="button"
              onClick={() => onCancel ? onCancel() : navigate('/authors')}
              className="flex-1 bg-gray-100 text-gray-700 py-2 px-4 rounded-md hover:bg-gray-200 transition-colors"
              disabled={createAuthor.isPending}
            >
              Abbrechen
            </button>
            <button
              type="submit"
              disabled={createAuthor.isPending || !name.trim()}
              className="flex-1 bg-blue-900 text-white py-2 px-4 rounded-md hover:bg-blue-800 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {createAuthor.isPending ? 'Speichern…' : 'Autor erstellen'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
